import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import styles from '../../pages/AgentSearch.scss';

AgentAgencyButtons.propTypes = {
  active: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

function AgentAgencyButtons(props) {
  const {active, url} = props;

  return (
    <ButtonGroup className={`w-100 ${styles.agentAgencyButtons}`} aria-label="Agent / Agency search">
      <Button component={Link} to={`/real-estate-agents/${url}`} className={`${styles.aaButton} ${active === 'agents' ? styles.active : ''}`}>Agents</Button>
      <Button component={Link} to={`/real-estate-agencies/${url}`} className={`${styles.aaButton} ${active === 'agencies' ? styles.active : ''}`}>Agencies</Button>
    </ButtonGroup>
  );
}

export default AgentAgencyButtons;
